import { useAppInitiator } from 'providers/AppInitiator';
import { useState } from 'react';
import Paths from './paths';
import axios from 'axios';
import { IDump } from 'types';
import { useQuery } from 'react-query';
import { REACT_APP_DUMP_URL } from './config';
import i18n from 'i18n';

export function useDump() {
  const [dump, setDump] = useState<IDump | null>(null);
  const { boot } = useAppInitiator();

  const populateWorkspace = (data) => {
    return { ...data, workspace: { available: [] } };
  };

  const url = `${Paths.join(boot.backends.api.baseUrl, REACT_APP_DUMP_URL)}`;
  const queryInfo = useQuery('dump', () =>
    // follow redirects, errore keycloak "no code" con redirect su login
    axios.get(url, { maxRedirects: 5, withCredentials: true }),
  {
    enabled: true,
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      setDump(data.workspace ? data : populateWorkspace(data));
      if (data && data.user && data.user.lang) {
        // la chiamata a changeLanguage sovrascrive il valore rilevato dal languagedetector
        i18n.changeLanguage(data.user.lang);
      }
    },
    onError: ({ error }) => {
      console.error('dump error ', error);
    },
  });

  return { dump, queryInfo };
}
